'use strict';

export let CrearUsuarioComponent = {
    selector: 'crearUsuario',
    template: require('./crear-usuario.html'),
    controller: class {

        /*@ngInject*/
        constructor(UsuarioService, $location, ToasterService) {
            Object.assign(this, {UsuarioService, $location, ToasterService});
            this.usuario = {};
        }
        
        crearUsuario(form){
            if (form.$valid){
                this.UsuarioService.crearUsuario(this.usuario)
                    .then(() =>{
                        this.ToasterService.popUp('success','Usuario', 'Se ha creado con éxito.');
                        this.$location.path('/usuarios');
                    })
                    .catch( error => {
                        let err = error.data;
                        if (err.errors.email) {
                            this.ToasterService.popUp('error', 'Usuario', err.errors.email.message);
                        } else if (err.errors.usuario) {
                            this.ToasterService.popUp('error', 'Usuario', err.errors.usuario.message);
                        } else {
                            this.ToasterService.popUp('error', 'Usuario', 'Error al crear el usuario.');
                        }
                    })
            }
        }
    }
};


// WEBPACK FOOTER //
// ./client/app/usuario-route/crear/crear-usuario.component.js